import http from "@utils/api/http";

export default class Base<C, U> {
  http = async <T>(
    url: string,
    type: string,
    variables: T | null = null,
    options?: any
  ) => {
    return (http as any)[type](url, variables, options);
  };
  all = async (url: string, locale: string = "vi") => {
    return this.http(url, "get");
  };

  find = async (url: string, locale: string = "vi") => {
    return this.http(url, "get");
  };

  create = async (url: string, variables: C, locale: string = "vi") => {
    return this.http<C>(url, "post", variables, {
      headers: { 'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8;application/json;'}
    });
  };

  update = async (url: string, variables: U, locale: string = "vi") => {
    return this.http<U>(url, "post", variables, {
      headers: { 'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8;application/json;'}
    });
  };

  delete = async (url: string, localeOrConfig: any = "vi", variables: U = {} as U) => {
    // Support two usages:
    //  - delete(url, { params: { id } })
    //  - delete(url, '', { id })
    let config: any = {};
    if (localeOrConfig && typeof localeOrConfig === "object") {
      config = { ...localeOrConfig };
    }
    if (variables && Object.keys(variables as any).length > 0) {
      config.params = { ...(config.params || {}), ...(variables as any) };
    }
    return this.http(url, "delete", config);
  };

  updatePatch = async (url: string, variables: U, locale: string = "vi") => {
    return this.http<U>(url, "patch", variables);
  };

  updateShopPatch = async (url: string) => {
    return this.http<U>(url, "patch");
  };

  updatePut = async (url: string, variables: U, locale: string = "vi") => {
    return this.http<U>(url, "put", variables, {
      headers: { 'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8;application/json;' }
    });
  };
}
